export default __webpack_public_path__ + "static/media/inklink logo.aa37dc65.svg";